<template>
  <div class="clock-in" v-if="show">
    <el-button
      :class="['clock-in-btn', `btn-status-${seatClockStatus}`, {['btn-timeOut']: timeOut}]"
      :type="seatClockStatus"
      size="small"
      :disabled="timeOut && seatClockStatus !== 'success'"
      @click="clockIn"
      >{{ clockInProgressCn }}</el-button>
  </div>
</template>

<script>
import {mapState} from "vuex";
import { callHelper } from "@/utils/helper/caller.helper";

export default {
  data(){
    const nowTime = Date.now();
    const deadlineTime = new Date().setHours(17, 30, 0);
    return {
      show: false,
      timeOut: nowTime >= deadlineTime,  //是否超时，不能打卡
    }
  },
  computed: {
    ...mapState('global', ['seatClockStatus']),
    clockInProgressCn(){
      const {seatClockStatus} = this;
      if (['info', 'warning'].includes(seatClockStatus)) return '上班签到';
      if (seatClockStatus === 'success') return '已签到';
      return '';
    }
  },
  mounted(){
    this.getClockInStatus();
  },
  methods: {
    // 更新坐席签到状态
    setSeatClockStatus(flag){
      this.$store.commit('global/setSeatClockStatus', flag);
    },
    // 获取打卡信息
    getClockInStatus(){
      this.$store.dispatch('global/getClockInStatus').then((res={}) => {
        if (res.code !== '000000') return;
        const {data} = res;

        if ([true, false].includes(data)) this.show = true;

        if (data === false){
          this.setSeatClockStatus(this.timeOut ? 'info' : 'warning')
        }
        if (data === true) this.clockSuccess();
      })
    },
    // 打卡
    clockIn(){
      if (!(['info', 'warning'].includes(this.seatClockStatus) && !this.timeOut)) return;

      this.$store.dispatch('global/clockIn').then((res={}) => {
        if (res.code === '000000' && res.data){
          this.$message.success('打卡成功');
          this.clockSuccess();
        }
      })
    },
    // 签到成功回调
    clockSuccess(){
      this.setSeatClockStatus('success');
      callHelper.register();
    },
  },
}
</script>

<style lang="scss" scoped>
.clock-in{
  &-btn{
    border-radius: 6px;
    &.btn-status-success{
      cursor: not-allowed;
      &:hover,
      &:focus,
      &:active{
        background-color: #67C23A;
        border-color: #67C23A;
      }
    }
  }
}
</style>
